/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
import { ReactComponent as ChevronRight } from '../../resources/images/chevron-right.svg';

/* Styles */
import styles from "./styles.js"

const Breadcrumbs = ({items}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.breadcrumbs}>
      {
        items.map((item, i) => {
          const isLastItem = i === items.length-1;

          return (
            <React.Fragment key={i}>
              <span className={ isLastItem ? `${classes.lastItem} ${classes.breadItem}` : classes.breadItem } key={i}>{ item }</span>
              {
                i < items.length-1 && <ChevronRight className={classes.chevron}/>
              }
            </React.Fragment>
          )
        })
      }
    </div>
  )
}

export default Breadcrumbs;
